/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AncillarySupplierFormConfiguration,
    AncillarySupplierFormConfigurationFromJSON,
    AncillarySupplierFormConfigurationToJSON,
    AncillarySupplierFormData,
    AncillarySupplierFormDataFromJSON,
    AncillarySupplierFormDataToJSON,
    AncillarySupplierValidationData,
    AncillarySupplierValidationDataFromJSON,
    AncillarySupplierValidationDataToJSON,
} from '../models';

export interface ApiAncillarySupplierFormConfigurationGetRequest {
    ancillaryCategory?: number;
}

export interface ApiAncillarySupplierFormCreatePostRequest {
    ancillarySupplierFormData?: AncillarySupplierFormData;
}

export interface ApiAncillarySupplierFormDataGetRequest {
    id?: string;
}

export interface ApiAncillarySupplierFormUpdatePostRequest {
    ancillarySupplierFormData?: AncillarySupplierFormData;
}

export interface ApiAncillarySupplierFormValidatePostRequest {
    ancillarySupplierFormData?: AncillarySupplierFormData;
}

/**
 * no description
 */
export class AncillarySupplierFormApi extends runtime.BaseAPI {

    /**
     */
    async apiAncillarySupplierFormConfigurationGetRaw(requestParameters: ApiAncillarySupplierFormConfigurationGetRequest): Promise<runtime.ApiResponse<AncillarySupplierFormConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.ancillaryCategory !== undefined) {
            queryParameters['ancillaryCategory'] = requestParameters.ancillaryCategory;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AncillarySupplierForm/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AncillarySupplierFormConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiAncillarySupplierFormConfigurationGet(requestParameters: ApiAncillarySupplierFormConfigurationGetRequest): Promise<AncillarySupplierFormConfiguration> {
        const response = await this.apiAncillarySupplierFormConfigurationGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiAncillarySupplierFormCreatePostRaw(requestParameters: ApiAncillarySupplierFormCreatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AncillarySupplierForm/Create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AncillarySupplierFormDataToJSON(requestParameters.ancillarySupplierFormData),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiAncillarySupplierFormCreatePost(requestParameters: ApiAncillarySupplierFormCreatePostRequest): Promise<void> {
        await this.apiAncillarySupplierFormCreatePostRaw(requestParameters);
    }

    /**
     */
    async apiAncillarySupplierFormDataGetRaw(requestParameters: ApiAncillarySupplierFormDataGetRequest): Promise<runtime.ApiResponse<AncillarySupplierFormData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AncillarySupplierForm/Data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AncillarySupplierFormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiAncillarySupplierFormDataGet(requestParameters: ApiAncillarySupplierFormDataGetRequest): Promise<AncillarySupplierFormData> {
        const response = await this.apiAncillarySupplierFormDataGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiAncillarySupplierFormUpdatePostRaw(requestParameters: ApiAncillarySupplierFormUpdatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AncillarySupplierForm/Update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AncillarySupplierFormDataToJSON(requestParameters.ancillarySupplierFormData),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiAncillarySupplierFormUpdatePost(requestParameters: ApiAncillarySupplierFormUpdatePostRequest): Promise<void> {
        await this.apiAncillarySupplierFormUpdatePostRaw(requestParameters);
    }

    /**
     */
    async apiAncillarySupplierFormValidatePostRaw(requestParameters: ApiAncillarySupplierFormValidatePostRequest): Promise<runtime.ApiResponse<AncillarySupplierValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AncillarySupplierForm/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AncillarySupplierFormDataToJSON(requestParameters.ancillarySupplierFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AncillarySupplierValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiAncillarySupplierFormValidatePost(requestParameters: ApiAncillarySupplierFormValidatePostRequest): Promise<AncillarySupplierValidationData> {
        const response = await this.apiAncillarySupplierFormValidatePostRaw(requestParameters);
        return await response.value();
    }

}
